module.exports = __webpack_public_path__ + "static/media/arrow.4b7fc7c6.svg";